import ApiService from "@/services/api.service";

const state = {
  providers: [],
  providerProjects: [],
  providerContacts: [],
  provider: "",
};

const getters = {
  getproviders(state) {
    return state.users;
  },
  getproviderContacts(state) {
    return state.providerContacts;
  },
};

const actions = {
  fetchproviders({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getproviders/", payload)
        .then(({ data }) => {
          commit("setproviders", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchprovider({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getproviderbyid/", {
        id: payload,
      })
        .then(({ data }) => {
          commit("setprovider", data);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchproviderProjects({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getprojects/", payload)
        .then(({ data }) => {
          commit("setproviderProjects", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  fetchproviderContacts({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getusers/", payload)
        .then(({ data }) => {
          commit("setproviderContacts", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
};

const mutations = {
  setproviders(state, payload) {
    state.providers = payload;
  },
  setprovider(state, payload) {
    state.provider = payload;
  },
  setproviderProjects(state, payload) {
    state.providerProjects = payload;
  },
  setproviderContacts(state, payload) {
    state.providerContacts = payload;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
